export const Update_User_Password = async (updateOBJ) => {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    try {
        const response = await fetch(`${ApiURL}User/update_password`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
            body: JSON.stringify(updateOBJ)
        });
        const responseData = await response.json();
        if (response.status === 200 && responseData.success === true) {
            return { data: responseData.msg, isSuccess: true };
        } else {
            return { data: responseData.msg, isSuccess: false };
        }
    } catch (error) {
        console.error("An error occurred during the fetch:", error);
        return { data: error, isSuccess: false };
    }
};



export const Unlock_User = async (updateOBJ) => {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    try {
        const response = await fetch(`${ApiURL}User/unlock_user`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authToken}`
            },
            body: JSON.stringify(updateOBJ)
        });
        const responseData = await response.json();
        if (response.status === 200 && responseData.success === true) {
            return { data: responseData.msg, isSuccess: true };
        } else {
            return { data: responseData.msg, isSuccess: false };
        }
    } catch (error) {
        console.error("An error occurred during the fetch:", error);
        return { data: error, isSuccess: false };
    }
};
